import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { FormControl, FormLabel } from "@/components/essentials/form-control";
import { type ChildSexFormValue } from "./type";
import { Select } from "@/components/essentials/select";
import { childSexes, childSexFormLabelTestId, childSexFormSelectSexTestId, childSexFormTestId } from "./const";

export const ChildSexForm: FC = () => {
  const {
    register,
    formState: { errors, dirtyFields },
  } = useFormContext<ChildSexFormValue>();
  return (
    <FormControl
      id="childSex"
      isRequired
      isDirty={dirtyFields.child?.sexCode}
      isInvalid={errors.child?.sexCode !== undefined}
      data-testid={childSexFormTestId}
    >
      <FormLabel data-testid={childSexFormLabelTestId}>性別</FormLabel>
      <Select
        data-testid={childSexFormSelectSexTestId}
        placeholder="選択してください"
        autoComplete="on"
        {...register("child.sexCode", { required: true })}
      >
        {childSexes.map(({ sexCode, label }, key) => (
          <option key={key} value={sexCode}>
            {label}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};
